/**
 * iurop-scratch-popup.js — Rasca y gana (Glucody).
 *
 * Mismo motor que la version de Gudslip. Lo que cambia:
 *
 * 1. El premio NO ES UN PORCENTAJE. Alli cada premio era un `pct` que se
 *    pintaba como "15%"; aqui es una ETIQUETA libre ("Muestras gratis",
 *    "Envio gratis"), porque los premios de Glucody no son descuentos.
 *
 * 2. EL CODIGO ES OPCIONAL, y eso decide que hace el premio por detras:
 *      sin codigo -> premio SOLO VISUAL. Es el caso de las muestras: ya se
 *                    anaden solas a cualquier carrito con productos (lo hace
 *                    iurop-cart-drawer.js), asi que el popup no tiene que
 *                    hacer nada mas que ensenarlo.
 *      con codigo -> se ENVIA POR EMAIL desde el flow de Klaviyo. El popup
 *                    confirma la entrega solo tras aceptar el alta en la lista.
 *
 * 3. EL FILTRO DE PREMIOS NO PUEDE EXIGIR CODIGO. En Gudslip era
 *    `p.code && p.weight > 0`, que descarta EN SILENCIO todo premio sin
 *    codigo: con este reparto el del 90% se caia del bombo y el del 10%
 *    pasaba a tocar el 100% de las veces, sin ningun error visible.
 *
 * 4. La etiqueta del dorado ("RASCA AQUI") se PINTA EN EL CANVAS, no viene
 *    horneada en el JPG: se traduce a los 6 idiomas y queda nitida a cualquier DPR.
 *
 * Persistencia: glucody:scratch-seen (fecha del ultimo cierre; reabre a los 7 dias)
 * · glucody:scratch-done (quienes ya completaron el juego no vuelven a verlo).
 */
(function () {
  'use strict';

  var DONE_KEY = 'glucody:scratch-done';
  var SEEN_KEY = 'glucody:scratch-seen';
  var RESHOW_AFTER_MS = 7 * 24 * 60 * 60 * 1000;
  var KLAVIYO_REVISION = '2024-10-15';

  // Los textos del JSON de premios los escribe el JS con textContent, que NO
  // decodifica entidades: un apostrofo escrito en el editor llega como &#39; y
  // se veria LITERAL en pantalla ("n&#39;importe quel produit"). El HTML normal
  // no sufre esto porque el navegador ya lo decodifica al parsear.
  function desescapar(s) {
    if (!s || s.indexOf('&') === -1) return s || '';
    var t = document.createElement('textarea');
    t.innerHTML = s;          // textarea: su contenido se parsea como TEXTO
    return t.value;
  }

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* bloqueado: el popup sigue funcionando */ } }
  function lsRemove(k) { try { window.localStorage.removeItem(k); } catch (e) { /* bloqueado: el popup sigue funcionando */ } }

  function cerradoRecientemente() {
    var guardado = lsGet(SEEN_KEY);
    if (!guardado) return false;

    // Migracion de la version anterior: `"1"` significaba ocultarlo para
    // siempre. Se transforma en un cierre de hoy para que respete los 7 dias
    // sin volver a impactar de golpe a todos los navegadores existentes.
    if (guardado === '1') {
      lsSet(SEEN_KEY, String(Date.now()));
      return true;
    }

    var cerradoEn = Number(guardado);
    var antiguedad = Date.now() - cerradoEn;
    if (Number.isFinite(cerradoEn) && cerradoEn > 0 && antiguedad >= 0 && antiguedad < RESHOW_AFTER_MS) {
      return true;
    }

    lsRemove(SEEN_KEY);
    return false;
  }

  function init() {
    var root = document.querySelector('[data-scratch-popup]');
    if (!root || root.dataset.scratchReady) return;
    root.dataset.scratchReady = '1';

    var designMode = root.getAttribute('data-design-mode') === 'true';
    var enabled = root.getAttribute('data-enabled') === 'true';
    var delayMs = (parseFloat(root.getAttribute('data-delay')) || 0) * 1000;
    var scrollThreshold = Math.max(0, Math.min(100, parseFloat(root.getAttribute('data-scroll-percent')) || 0)) / 100;
    var threshold = (parseFloat(root.getAttribute('data-threshold')) || 45) / 100;
    var lang = (root.getAttribute('data-lang') || '').trim();
    var country = (root.getAttribute('data-country') || '').trim();
    var codeNotice = (root.getAttribute('data-code-notice') || '').trim();

    var canvas = root.querySelector('[data-scratch-canvas]');
    var card = root.querySelector('[data-scratch-card]');
    var form = root.querySelector('[data-scratch-form]');
    var success = root.querySelector('[data-scratch-success]');
    var errorEl = root.querySelector('[data-scratch-error]');
    var prizeEl = root.querySelector('[data-scratch-prize]');
    var subtitleEl = root.querySelector('[data-scratch-subtitle]');

    // ── premios ─────────────────────────────────────────────────────────────
    var brutos = [];
    try { brutos = JSON.parse(root.querySelector('[data-scratch-prizes]').textContent) || []; } catch (e) {}

    // Un premio vale con TENER TEXTO y peso > 0. El codigo es OPCIONAL:
    //   sin codigo  -> premio SOLO VISUAL (las muestras ya entran en todos los
    //                  pedidos por la logica del carrito, no hay que hacer nada)
    //   con codigo  -> lo envia por email el flow de Klaviyo
    // Ojo: NO se puede exigir codigo para dar el premio por valido, que es lo
    // que hace la version de Gudslip; con este reparto el premio del 90% se
    // caeria del bombo y el del 10% tocaria siempre.
    function esValido(p) {
      return !!(p && p.label && p.weight > 0);
    }
    var prizes = [];
    brutos.forEach(function (p) {
      if (esValido(p)) { prizes.push(p); return; }
      // Nunca en silencio: un premio mal configurado cambia las probabilidades
      // de los demas (si cae el del 90%, el del 10% pasa a tocar SIEMPRE).
      if (p && (p.label || p.code)) {
        var falta = !p.label ? 'sin texto' : 'peso 0';
        console.warn('[scratch] premio descartado (' + falta + '):', p.label || p.id);
      }
    });
    if (!prizes.length) {
      console.error('[scratch] ningun premio valido: el popup no se abre.');
      return;
    }

    function pickPrize() {
      var total = prizes.reduce(function (a, p) { return a + p.weight; }, 0);
      var r = Math.random() * total;
      for (var i = 0; i < prizes.length; i++) {
        r -= prizes[i].weight;
        if (r <= 0) return prizes[i];
      }
      return prizes[prizes.length - 1];
    }
    var prize = null;

    // ── abrir / cerrar ──────────────────────────────────────────────────────
    var opened = false;
    function openPopup() {
      if (opened) return;
      opened = true;
      prize = pickPrize();
      if (prizeEl) prizeEl.textContent = desescapar(prize.label);
      root.hidden = false;
      document.documentElement.classList.add('glucody-scratch-open');
      // setTimeout y NO requestAnimationFrame: rAF se congela en pestanas en
      // segundo plano y el popup no llegaba a abrirse al volver a la pestana.
      window.setTimeout(function () {
        root.classList.add('is-open');
        setupCanvas();
      }, 30);
    }
    function closePopup(entregado) {
      if (!entregado && !designMode && lsGet(DONE_KEY) !== '1') {
        lsSet(SEEN_KEY, String(Date.now()));
      }
      root.classList.remove('is-open');
      document.documentElement.classList.remove('glucody-scratch-open');
      window.setTimeout(function () { root.hidden = true; }, 350);
    }
    var btnCerrar = root.querySelector('[data-scratch-close]');
    if (btnCerrar) btnCerrar.addEventListener('click', function () { closePopup(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && opened && !root.hidden) closePopup(false);
    });

    // ── canvas de rascado ───────────────────────────────────────────────────
    var ctx, revealed = false, strokes = 0;

    // Revelar vive FUERA de setupCanvas: lo llaman tanto el rascado como la
    // salida de emergencia de arriba (canvas que no llega a medir).
    var sinMovimiento = false;
    try { sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    // Revelado ESCALONADO. Si el dorado se deshace, el subtitulo desaparece y
    // el formulario entra todo a la vez, no se lee ninguna de las tres cosas;
    // separandolas el ojo sigue una sola cadena: se va el dorado -> el premio
    // da el golpe -> aparece el formulario.
    function revealFallback() {
      if (revealed) return;
      revealed = true;
      card.classList.add('is-revealed');

      var esperaSub = sinMovimiento ? 0 : 220;
      var esperaForm = sinMovimiento ? 0 : 300;

      if (subtitleEl) {
        subtitleEl.classList.add('is-out');
        window.setTimeout(function () { subtitleEl.hidden = true; }, esperaSub);
      }
      if (form) {
        window.setTimeout(function () {
          form.hidden = false;
          // Dos tiempos a proposito: un elemento que pasa de display:none a
          // visible NO transiciona en el mismo fotograma; hay que dejar que se
          // pinte oculto y anadir la clase despues.
          window.setTimeout(function () { form.classList.add('is-in'); }, 20);
          var em = form.querySelector('[data-scratch-email]');
          if (em && window.matchMedia('(min-width: 750px)').matches) em.focus();
        }, esperaForm);
      }
    }

    function pintarEtiqueta() {
      var texto = (canvas.getAttribute('data-foil-label') || '').trim();
      if (!texto) return;
      var w = canvas.width, h = canvas.height;
      ctx.save();
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.62)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var size = Math.round(w * 0.115);
      try { ctx.letterSpacing = Math.round(size * 0.06) + 'px'; } catch (e) { /* navegador viejo: sin tracking */ }
      ctx.font = '600 ' + size + 'px Poppins, system-ui, sans-serif';
      // Si el texto no cabe a lo ancho de la tarjeta, se reduce hasta que quepa.
      var margen = w * 0.86;
      while (ctx.measureText(texto).width > margen && size > 8) {
        size -= 1;
        ctx.font = '600 ' + size + 'px Poppins, system-ui, sans-serif';
      }
      ctx.fillText(texto, w / 2, h / 2);
      ctx.restore();
    }

    // Si la tarjeta todavia no ha maquetado, su rect mide 0 y el canvas nacia
    // 0x0: el dorado no se pintaba, el premio quedaba a la vista sin rascar y
    // -lo grave- el formulario NUNCA aparecia (solo lo abre el rascado), asi
    // que el popup no capturaba ni un email. Reintentamos mientras no haya
    // medida y, si al cabo de un segundo sigue sin haberla, revelamos directo:
    // mejor ensenar el premio que dejar al visitante en un callejon sin salida.
    var intentos = 0;
    function setupCanvas() {
      if (!canvas || canvas.dataset.ready) return;
      var rect = card.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) {
        if (++intentos < 60) { window.setTimeout(setupCanvas, 16); return; }
        canvas.dataset.ready = '1';
        canvas.hidden = true;
        revealFallback();
        return;
      }
      canvas.dataset.ready = '1';
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      ctx = canvas.getContext('2d', { willReadFrequently: true });

      function dibujarDorado(dibujarImagen) {
        // scratchTo deja el contexto en 'destination-out' y no lo restaura: si
        // este repintado corre despues de que el visitante haya empezado a
        // rascar, el drawImage BORRARIA el canvas entero en vez de pintarlo.
        ctx.globalCompositeOperation = 'source-over';
        if (dibujarImagen) dibujarImagen();
        // Las fuentes pueden no estar listas: se pinta ya con la de respaldo y
        // se repinta con Poppins en cuanto cargue (si no, el texto sale en otra
        // tipografia y con otra anchura).
        pintarEtiqueta();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            if (revealed || strokes > 0) return;   // ya esta rascando: no repintar
            ctx.globalCompositeOperation = 'source-over';
            if (dibujarImagen) dibujarImagen();
            pintarEtiqueta();
          });
        }
      }

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        dibujarDorado(function () { ctx.drawImage(img, 0, 0, canvas.width, canvas.height); });
      };
      img.onerror = function () {
        // Sin textura (asset caido): dorado plano, el juego sigue igual.
        dibujarDorado(function () {
          var g = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
          g.addColorStop(0, '#d5c1aa');
          g.addColorStop(1, '#a18d76');
          ctx.fillStyle = g;
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        });
      };
      img.src = canvas.getAttribute('data-foil');

      var scratching = false, last = null;
      function pos(e) {
        var r = canvas.getBoundingClientRect();
        return {
          x: ((e.clientX - r.left) / r.width) * canvas.width,
          y: ((e.clientY - r.top) / r.height) * canvas.height
        };
      }
      function scratchTo(p) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineWidth = canvas.width * 0.14;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo((last || p).x, (last || p).y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
        last = p;
      }
      // Medir cuanto se ha rascado leyendo el canvas ENTERO es lo que hacia
      // que el dedo fuese a tirones en movil: getImageData de 696x510 son
      // ~355.000 pixeles, y se hacia cada 6 trazos mientras el usuario arrastra.
      // Aqui el canvas se vuelca reducido a uno de ~64px (drawImage escala por
      // GPU) y se leen ~3.000 pixeles: unas 100 veces menos trabajo. Ademas el
      // resultado es MEJOR que antes: el reducido promedia el alfa de cada
      // zona, en vez de muestrear 1 de cada 8 pixeles sueltos.
      var mini = document.createElement('canvas');
      mini.width = 64;
      mini.height = Math.max(1, Math.round(64 * canvas.height / canvas.width));
      var miniCtx = mini.getContext('2d', { willReadFrequently: true });

      function clearedRatio() {
        miniCtx.clearRect(0, 0, mini.width, mini.height);
        miniCtx.drawImage(canvas, 0, 0, mini.width, mini.height);
        var data = miniCtx.getImageData(0, 0, mini.width, mini.height).data;
        var clear = 0, total = 0;
        for (var i = 3; i < data.length; i += 4) {
          total++;
          if (data[i] < 128) clear++; // zona mas rascada que intacta
        }
        return total ? clear / total : 0;
      }
      function maybeReveal(force) {
        if (revealed) return;
        // Ahora que medir es barato se comprueba cada 3 trazos en vez de cada 6:
        // el premio salta antes al cruzar el umbral y no se queda esa sensacion
        // de "ya lo he rascado entero y no pasa nada".
        if (!force && ++strokes % 3 !== 0) return;
        if (clearedRatio() >= threshold) reveal();
      }
      var reveal = revealFallback;
      canvas.addEventListener('pointerdown', function (e) {
        scratching = true; last = null; scratchTo(pos(e));
        canvas.setPointerCapture(e.pointerId);
      });
      canvas.addEventListener('pointermove', function (e) {
        if (!scratching) return;
        e.preventDefault();
        scratchTo(pos(e));
        maybeReveal(false);
      });
      canvas.addEventListener('pointerup', function () { scratching = false; last = null; maybeReveal(true); });
      canvas.addEventListener('pointercancel', function () { scratching = false; last = null; });
    }

    // Al girar el movil la tarjeta pasa de 177 a 348px de caja y el dorado se
    // veia estirado desde el lienzo viejo. Si aun no se ha revelado, se rehace
    // el canvas a la medida nueva (se pierde lo rascado, que es coherente: el
    // lienzo es otro).
    var anchoPrevio = 0;
    window.addEventListener('resize', function () {
      if (!opened || revealed || !canvas || !card) return;
      var ancho = Math.round(card.getBoundingClientRect().width);
      if (!ancho || Math.abs(ancho - anchoPrevio) < 8) return;
      anchoPrevio = ancho;
      delete canvas.dataset.ready;
      strokes = 0;
      setupCanvas();
    }, { passive: true });

    // ── Klaviyo (client API: publica, pensada para navegador) ───────────────
    var companyId = (root.getAttribute('data-klaviyo-key') || '').trim();
    var listId = (root.getAttribute('data-klaviyo-list') || '').trim();

    function ganoEnvioGratis() {
      return prize && prize.id === 'premio2' ? 'true' : 'false';
    }

    function klaviyoPost(path, payload) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(payload)
      });
    }

    // OJO con la forma del payload, comprobada contra la API real:
    //  · `subscriptions` NO es un campo valido del perfil aqui -> 400
    //    ("'subscriptions' is not a valid field for the resource 'profile'").
    //    El consentimiento es implicito: este endpoint ES el de suscribir.
    //  · `list` es una relacion OBLIGATORIA -> sin lista, 400 SIEMPRE
    //    ("'list' is a required relationship"). La lista sale del idioma.
    function subscribe(email) {
      var profileProperties = { scratch_envio_gratis: ganoEnvioGratis() };
      return klaviyoPost('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Scratch & Win popup',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              properties: profileProperties
            } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      });
    }

    function trackWin(email) {
      return klaviyoPost('events', {
        data: {
          type: 'event',
          attributes: {
            // El flow se ramifica por prize_type: "codigo" manda el codigo,
            // "carrito" solo confirma que el regalo ya esta en el carrito.
            properties: {
              prize: prize.label,
              // Texto explicito para que el editor visual filtre con "true"/"false".
              scratch_envio_gratis: ganoEnvioGratis(),
              // 'codigo' -> el flow adjunta/envia el codigo · 'visual' -> solo avisa
              prize_type: prize.code ? 'codigo' : 'visual',
              // El flow ramifica el correo con esto. Si faltara, la plantilla
              // cae a espanol (probado), no se rompe.
              idioma: lang,
              pais: country,
              discount_code: prize.code || ''
            },
            metric: { data: { type: 'metric', attributes: { name: 'Scratch Win' } } },
            profile: { data: { type: 'profile', attributes: {
              email: email,
              properties: { scratch_envio_gratis: ganoEnvioGratis() }
            } } }
          }
        }
      });
    }

    function mostrarExito() {
      // Cada premio puede traer su propio texto de exito: el de las muestras
      // NO puede decir "te lo hemos enviado por correo" porque no se manda
      // nada — el pack entra solo en cuanto hay un producto en el carrito.
      if (success) {
        var txt = success.querySelector('[data-scratch-success-text]');
        if (txt && prize && prize.success) txt.textContent = desescapar(prize.success);

        // El codigo NO se ensena en pantalla: cada ganador recibe el SUYO por
        // correo desde el flow de Klaviyo (un codigo unico por persona). Aqui
        // solo se le avisa de que mire el buzon. La caja del codigo se queda
        // en el markup, oculta, por si algun dia se vuelve a entregar en
        // pantalla; asi no hay que tocar el liquid para volver atras.
        var caja = success.querySelector('[data-scratch-code]');
        if (caja) caja.hidden = true;
        if (txt && prize && prize.code && codeNotice) {
          txt.textContent = (txt.textContent + ' ' + codeNotice).trim();
        }
        success.hidden = false;
      }
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var campo = form.querySelector('[data-scratch-email]');
        var email = ((campo && campo.value) || '').trim();
        var consent = form.querySelector('[data-scratch-consent]');
        var btn = form.querySelector('[data-scratch-submit]');
        // El email y el consentimiento los corrige el visitante. La clave y la
        // lista son configuracion nuestra: si faltan, NO se confirma el envio,
        // porque el flow de Klaviyo nunca podria entregar el premio.
        if (!/.+@.+\..+/.test(email) || !consent || !consent.checked) {
          if (consent && !consent.checked) consent.focus();
          return;
        }
        btn.disabled = true;
        // La respuesta 202/2xx significa que Klaviyo ha aceptado la peticion.
        // Antes cualquier 4xx/5xx o fallo de red se tragaba aqui y el popup
        // mostraba igualmente "te lo hemos enviado", marcando DONE para siempre.
        // La suscripcion a la lista es el trigger real del flow: si no queda
        // aceptada, se mantiene el formulario para que el visitante reintente.
        function exigirAceptado(nombre, p) {
          return p.then(function (r) {
            if (r && r.ok) return r;
            var status = r ? r.status : 0;
            return (r && r.text ? r.text() : Promise.resolve('')).then(function (t) {
              throw new Error(nombre + ' (' + status + ')' + (t ? ': ' + t : ''));
            });
          });
        }
        var alta;
        if (!companyId) alta = Promise.reject(new Error('falta la Public API Key de Klaviyo'));
        else if (!listId) alta = Promise.reject(new Error('falta la lista de Klaviyo para este idioma'));
        else alta = exigirAceptado('alta en Klaviyo', subscribe(email));

        alta
          .then(function () {
            // El email lo activa el alta en la lista. El evento se conserva
            // para analitica y para poder migrar el flow a Scratch Win, pero
            // no invalida una suscripcion que Klaviyo ya ha aceptado.
            return exigirAceptado('evento Scratch Win', trackWin(email)).catch(function (e) {
              console.error('[scratch] ' + e.message);
            });
          })
          .then(function () {
            lsSet(DONE_KEY, '1');
            form.hidden = true;
            mostrarExito();
            // El auto-cierre viene de cuando el codigo se mandaba por EMAIL y
            // esta pantalla era solo un acuse de recibo. Ahora el codigo ES la
            // entrega: cerrar a los 3,5s se lo lleva puesto, y como DONE ya
            // esta guardado el popup NO vuelve a abrirse nunca. Si el premio
            // lleva codigo, que lo cierre el visitante cuando lo tenga.
            if (!(prize && prize.code)) {
              window.setTimeout(function () { closePopup(true); }, 3500);
            }
          })
          .catch(function (e) {
            console.error('[scratch] no se pudo completar el alta:', e && e.message);
            btn.disabled = false;
            if (errorEl) {
              errorEl.textContent = form.getAttribute('data-error-text') || '';
              errorEl.hidden = false;
            }
          });
      });
    }

    // Copiar al portapapeles. Con respaldo para navegadores sin Clipboard API
    // o sin https: un textarea + execCommand, que sigue funcionando en todos.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-scratch-copy]');
      if (!btn) return;
      var val = root.querySelector('[data-scratch-code-value]');
      var cod = val ? val.textContent.trim() : '';
      if (!cod) return;
      var hecho = function () {
        btn.textContent = btn.getAttribute('data-copied') || btn.textContent;
        btn.classList.add('is-copied');
        window.setTimeout(function () {
          btn.textContent = btn.getAttribute('data-copy') || '';
          btn.classList.remove('is-copied');
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(cod).then(hecho, function () { respaldo(cod, hecho); });
      } else {
        respaldo(cod, hecho);
      }
    });
    function respaldo(texto, hecho) {
      try {
        var ta = document.createElement('textarea');
        ta.value = texto;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        hecho();
      } catch (err) { /* si no se puede copiar, el codigo sigue visible para teclearlo */ }
    }

    // ── disparo ─────────────────────────────────────────────────────────────
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target.contains(root)) openPopup();
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (!e.target.contains(root)) return;
        closePopup(false);
        // Sin esto el editor solo lo abre UNA vez y siempre con el mismo
        // premio: el comerciante no puede previsualizar los demas.
        window.setTimeout(function () {
          opened = false; revealed = false; strokes = 0; intentos = 0; prize = null;
          card.classList.remove('is-revealed');
          if (canvas) { delete canvas.dataset.ready; canvas.hidden = false; }
          if (form) { form.hidden = true; form.classList.remove('is-in'); }
          if (success) success.hidden = true;
          if (subtitleEl) { subtitleEl.hidden = false; subtitleEl.classList.remove('is-out'); }
        }, 400);
      });
      return;
    }
    if (!enabled) return;
    if (lsGet(DONE_KEY) === '1') return;
    if (cerradoRecientemente()) return;
    // El fondo va lazy en el markup (para no pesar si el visitante no llega a
    // verlo), pero si el popup VA a abrirse se precarga durante el retardo: sin
    // esto se abria con la pagina visible detras hasta que llegaba la foto.
    Array.prototype.forEach.call(root.querySelectorAll('.glucody-scratch__bg'), function (img) {
      img.loading = 'eager';
      if (!img.complete && img.src) { var pre = new Image(); pre.src = img.currentSrc || img.src; }
    });

    // El banner de cookies MANDA: es un requisito legal que se pueda usar, y va
    // a z-index 2147483000 justo porque el popup de Klaviyo ya le tapo el boton
    // de Aceptar una vez (ver iurop-cookies.scss). Este popup no compite por
    // z-index: si el banner esta abierto, espera a que el visitante decida y
    // solo entonces arranca su retardo. iurop-cookies.js pone y quita la clase
    // `has-cookie-banner` en el <body>.
    // La comprobacion del banner va en el MOMENTO DE ABRIR, no aqui. En
    // DOMContentLoaded la clase todavia no existe: iurop-cookies.js llama a
    // show() dentro de withCustomerPrivacy, que espera a Shopify.loadFeatures
    // (ida y vuelta de red). Mirandolo al arrancar, la rama del observador no
    // se ejecutaba casi nunca y el popup se abria ENCIMA del banner.
    function hayBanner() {
      var bannerActual = document.getElementById('gc-cookies');
      return document.body.classList.contains('has-cookie-banner') ||
        !!(bannerActual && bannerActual.classList.contains('is-open'));
    }
    var delayCumplido = false;
    var scrollCumplido = scrollThreshold === 0;
    var observadorCookies = null;

    function progresoScroll() {
      var doc = document.documentElement;
      var recorrido = Math.max(doc.scrollHeight - window.innerHeight, 0);
      if (recorrido === 0) return 1;
      return Math.max(0, Math.min(1, (window.scrollY || doc.scrollTop || 0) / recorrido));
    }

    function limpiarDisparadores() {
      window.removeEventListener('scroll', comprobarScroll);
      if (observadorCookies) {
        observadorCookies.disconnect();
        observadorCookies = null;
      }
    }

    function intentarAbrir() {
      if (!delayCumplido || !scrollCumplido || hayBanner()) return;
      limpiarDisparadores();
      openPopup();
    }

    function comprobarScroll() {
      if (scrollCumplido || progresoScroll() < scrollThreshold) return;
      scrollCumplido = true;
      window.removeEventListener('scroll', comprobarScroll);
      intentarAbrir();
    }

    comprobarScroll();
    if (!scrollCumplido) window.addEventListener('scroll', comprobarScroll, { passive: true });

    observadorCookies = new MutationObserver(intentarAbrir);
    observadorCookies.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });
    var bannerActual = document.getElementById('gc-cookies');
    if (bannerActual) observadorCookies.observe(bannerActual, { attributes: true, attributeFilter: ['class'] });

    window.setTimeout(function () {
      delayCumplido = true;
      intentarAbrir();
    }, delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
